import { formatGr } from '@odhaczka/core';
import { articleName } from '../../data/prices';
import { linePaidGr, type ReceiptLineView } from '../../data/receipts';

const qtyText = (l: ReceiptLineView) =>
  l.weight ? `${(l.qty ?? 0).toLocaleString('pl-PL', { maximumFractionDigits: 3 })} kg × ${formatGr(l.unitGr ?? 0)}` : `${l.qty ?? 1} × ${formatGr(l.unitGr ?? 0)}`;

/** Linia paragonu: czytelna nazwa, nazwa kasowa, ilość × cena, rabaty i kwota po rabatach. */
export function ReceiptLine({ line, children, onClick }: { line: ReceiptLineView; children?: React.ReactNode; onClick?: () => void }) {
  const name = line.article ? articleName(line.article) : (line.rawName ?? '');
  const raw = line.rawName && line.rawName !== name ? line.rawName : null;
  const body = (
    <div className="flex items-start gap-3">
      <div className="min-w-0 flex-1">
        <div className="leading-snug break-words">{name}</div>
        <div className="text-xs text-stone-500">
          {raw && <span className="mr-1.5">{raw} ·</span>}
          <span className="tabular-nums">{qtyText(line)}</span>
          {line.discountGr ? (
            <span className="text-brand-700 dark:text-brand-500">
              {' '}
              · {line.discounts ?? 'rabat'} −{formatGr(line.discountGr, false)}
            </span>
          ) : null}
        </div>
        {children}
      </div>
      <div className="shrink-0 text-right font-medium tabular-nums">{formatGr(linePaidGr(line))}</div>
    </div>
  );
  return onClick ? (
    <button type="button" onClick={onClick} className="block w-full px-4 py-3 text-left active:bg-stone-100 dark:active:bg-stone-800">
      {body}
    </button>
  ) : (
    <div className="px-4 py-3">{body}</div>
  );
}
